// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.styles_cardInform__3gKvJ {
  max-height: 80vh;
  background-color: #f2f2f2;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  margin: 1rem 0 3rem 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}

.styles_cardIform__title__egkab {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #18316e;
  font-family: "Inter";
}

.styles_cardInform__img__jQPoA {
  width: 25rem;
  border-radius: 8px;
}

.styles_cardInform__descript__aKgPW {
  box-sizing: border-box;
  display: flex;
  text-align: center;
  font-size: 1rem;
  font-family: "Inter";
  font-weight: 400;
  color: #464a53;
  margin-bottom: 40px;
}

.styles_cardInform__descript__aKgPW span {
  width: 25rem;
}

.styles_cardInform__logo__NVFd1 {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  height: 6rem;
}
.styles_cardInform__logo__NVFd1 img {
  max-width: 9rem;
  overflow: hidden;
}

@media (max-width: 425px) {
  .styles_cardInform__3gKvJ {
    margin-inline: 1rem;
    padding: 0.5rem;
  }

  .styles_cardIform__title__egkab {
    font-size: 1.1rem;
  }

  .styles_cardInform__img__jQPoA {
    width: 75vw;
  }

  .styles_cardInform__descript__aKgPW {
    font-size: 0.8rem;
  }

  .styles_cardInform__descript__aKgPW span {
    width: 15rem;
  }

  .styles_cardInform__logo__NVFd1 {
    height: 5rem;
  }

  .styles_cardInform__logo__NVFd1 img {
    max-width: 30vw;
    min-width: 25vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardInform/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.cardInform {\n  max-height: 80vh;\n  background-color: #f2f2f2;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n  margin: 1rem 0 3rem 0;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n}\n\n.cardIform__title {\n  font-size: 22px;\n  font-weight: 700;\n  text-align: center;\n  color: #18316e;\n  font-family: \"Inter\";\n}\n\n.cardInform__img {\n  width: 25rem;\n  border-radius: 8px;\n}\n\n.cardInform__descript {\n  box-sizing: border-box;\n  display: flex;\n  text-align: center;\n  font-size: 1rem;\n  font-family: \"Inter\";\n  font-weight: 400;\n  color: #464a53;\n  margin-bottom: 40px;\n}\n\n.cardInform__descript span {\n  width: 25rem;\n}\n\n.cardInform__logo {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  height: 6rem;\n}\n.cardInform__logo img {\n  max-width: 9rem;\n  overflow: hidden;\n}\n\n@media (max-width: 425px) {\n  .cardInform {\n    margin-inline: 1rem;\n    padding: 0.5rem;\n  }\n\n  .cardIform__title {\n    font-size: 1.1rem;\n  }\n\n  .cardInform__img {\n    width: 75vw;\n  }\n\n  .cardInform__descript {\n    font-size: 0.8rem;\n  }\n\n  .cardInform__descript span {\n    width: 15rem;\n  }\n\n  .cardInform__logo {\n    height: 5rem;\n  }\n\n  .cardInform__logo img {\n    max-width: 30vw;\n    min-width: 25vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardInform": `styles_cardInform__3gKvJ`,
	"cardIform__title": `styles_cardIform__title__egkab`,
	"cardInform__img": `styles_cardInform__img__jQPoA`,
	"cardInform__descript": `styles_cardInform__descript__aKgPW`,
	"cardInform__logo": `styles_cardInform__logo__NVFd1`
};
export default ___CSS_LOADER_EXPORT___;
